import React from "react";
import {
  appAccentPanelStyle,
  appNeutralPanelStyle,
  appPageContainerStyle,
  appSectionCardStyle,
} from "../../../components/general/uiSurfaceStyles";

export const dashboardPageContainerStyle = appPageContainerStyle;

export const dashboardSectionCardStyle = appSectionCardStyle;

export const dashboardAccentPanelStyle = appAccentPanelStyle;

export const dashboardNeutralPanelStyle = appNeutralPanelStyle;

export const renderDashboardHeader = (
  title: string,
  subtitle: string,
  actions?: React.ReactNode,
  leadingContent?: React.ReactNode,
) => {
  return (
    <div className="flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
      <div className="flex flex-wrap align-items-center gap-3">
        {leadingContent ? <div className="flex align-items-center">{leadingContent}</div> : null}
        <div>
          <div className="m-0" style={{ fontSize: "1.75rem", fontWeight: 700, lineHeight: 1.2, color: "#0f172a" }}>
            {title}
          </div>
          <div className="mt-2" style={{ color: "#596F80" }}>
            {subtitle}
          </div>
        </div>
      </div>
      {actions ? <div className="dashboard-header-actions flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
};
